export default "__VITE_ASSET__CQDpIumL__"